import './cookiewarning.less'

import {m} from '@codeurs/front'
import {Stream} from 'mithril/stream'
import {Component} from 'react'
import {LinkType} from 'types'
import {t} from 'util/i18n'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('cookiewarning')

export type CookiesType = {
	text: string
	accept: string
	info: LinkType
}

export class Cookiewarning extends Component<{
	cookies: Stream<boolean>
	cookiesData: CookiesType
}> {
	state = {hidden: true}

	componentDidMount() {
		const {cookies} = this.props
		if (!cookies()) setTimeout(() => this.setState({hidden: false}))
	}

	render() {
		const {cookies, cookiesData} = this.props
		const {hidden} = this.state

		return (
			<div class={styles.is({hidden})}>
				<div class={styles('content')}>
					<p class={styles('text')}>{cookiesData.text || t('cookies.text')}</p>
				</div>
				<div class={styles('buttons')}>
					<div class={styles('buttons-accept')}>
						<Theme.Button
							mod={['small', 'primary']}
							onClick={() => {
								cookies(true)
								this.setState({hidden: true})
							}}
						>
							{cookiesData.accept || t('cookies.accept')}
						</Theme.Button>
					</div>
					{cookiesData.info && (
						<Theme.Link
							class={styles('buttons-info')}
							to={cookiesData.info.url}
						>
							{cookiesData.info.description}
						</Theme.Link>
					)}
				</div>
			</div>
		)
	}
}
